import OrderIcon from "@/components/orders/OrderIcon";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_ORDERS_URL } from "@/core/urls";
import { ORGANISATION_ACCOUNT_BALANCE_QUERY } from "@/graphql/organisations/queries/commission";
import {
  ORGANISATION_ORDERS_LIST_QUERY,
  ORGANISATION_ORDER_BALANCE_QUERY
} from "@/graphql/organisations/queries/orders";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import ChevronComponent from "@/tpo/Chevron";
import LinkWrapper from "@/tpo/LinkWrapper";
import ButtonV2 from "@/v2/Buttons";
import { useQuery } from "@apollo/client";

import DashboardPanel from "../DashboardPanel";
import LatestOrdersList from "./LatestOrdersList";
import LatestOrdersPanelBalanceFooter from "./LatestOrdersPanelBalanceFooter";
import {
  cmpHomeDashboardBalanceFooterOuterPadding,
  cmpHomeDashboardListPageSize,
  cmpHomeDashboardPanelPadding,
  cmpHomeDashboardPanelTitleProps,
  cmpHomeDashboardScrollableListBoxProps
} from "./dashboardLayout";

export default function LatestOrdersPanel() {
  const { organisation } = useOrganisationContext();
  const { resolvedUrls } = useCmpRelatedUrl();

  const { data: orderBalanceData, loading: orderBalanceLoading } = useQuery(
    ORGANISATION_ORDER_BALANCE_QUERY,
    {
      variables: {
        organisation: parseInt(organisation?.id, 10)
      },
      skip: !organisation?.id
    }
  );

  const { data: commissionBalanceData, loading: commissionBalanceLoading } = useQuery(
    ORGANISATION_ACCOUNT_BALANCE_QUERY,
    {
      variables: {
        organisation: parseInt(organisation?.id, 10)
      },
      skip: !organisation?.id
    }
  );

  const { data, loading } = useQuery(ORGANISATION_ORDERS_LIST_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    variables: {
      organisation: parseInt(organisation?.id, 10),
      page: 1,
      pageSize: cmpHomeDashboardListPageSize,
      orderBy: "-checkout_date",
      filter: "all"
    },
    skip: !organisation?.id
  });

  const orders = data?.organisationOrdersPagination?.items;
  const orderBalance = orderBalanceData?.orderBalance;
  const commissionBalances = commissionBalanceData?.connectedAccountBalances;

  return (
    <DashboardPanel
      title="Latest orders"
      titleProps={cmpHomeDashboardPanelTitleProps}
      padding={cmpHomeDashboardPanelPadding}
      footerStackPb={cmpHomeDashboardBalanceFooterOuterPadding.pb}
      contentScrollProps={cmpHomeDashboardScrollableListBoxProps}
      headerStart={
        <OrderIcon width={60} iconSize={30} color="#1A1A1A" variant="outline" withCircle />
      }
      headerStartGap={16}
      headerWrap
      headerEnd={
        <ButtonV2
          color="dark"
          size="xs"
          as={LinkWrapper}
          to={resolvedUrls[CMP_ORDERS_URL]}
          rightIcon={<ChevronComponent />}
        >
          view all
        </ButtonV2>
      }
      footer={
        <LatestOrdersPanelBalanceFooter
          orderBalance={orderBalance}
          orderBalanceLoading={orderBalanceLoading}
          commissionBalances={commissionBalances}
          commissionBalanceLoading={commissionBalanceLoading}
        />
      }
    >
      <LatestOrdersList orders={orders} loading={loading} organisationId={organisation?.hashId} />
    </DashboardPanel>
  );
}
